// TODO: Handle print css via original table tag styles, instead of this seperate function
// current limitation: table tags not so flexible to work with css.

export default function printTableStyles(colLength) {
  return `
    #root > * {
        display: none;
    }
    #root > main {
        display: block;
    }
    #root > main > * {
        display: none;
    }
    #root > main > .model-details-specification-analytics-wrapper {
        display: block;
    }
    #root > main > .model-details-specification-analytics-wrapper > .model-details-specification-table-wrapper {
        display: block;
    }
    #root > main > .model-details-specification-analytics-wrapper > .model-detail-specification-table-wrapper > .model-detail-specification-table-header,
    #root > main > .model-details-specification-analytics-wrapper > .model-detail-specification-table-wrapper > .model-detail-specification-table,
    #root > main > .model-details-specification-analytics-wrapper > .model-detail-specification-table-wrapper > .model-detail-specification-table__search-no-match {
        display: none;
    }
    #root > main > .model-details-specification-analytics-wrapper > .model-detail-specification-table-wrapper > model-detail-specification-table-print {
        display: block;
        overflow: hidden;
        width: 100%;
    }
    .model-detail-specification-table-print {
        width: 100%;
        background-color: #ffffff;
        -webkit-print-color-adjust: exact;
    }
    .model-detail-specification-table-print__grid {
        display: grid;
        position: relative;
        grid-template-columns: repeat(${colLength}, auto);
        align-items: center;
        background-color: #ffffff;
        -webkit-print-color-adjust: exact;
    }
    .model-detail-specification-table-print-wrapper .print-navigation-logo-image{
        margin: 20px;
        display: block;
        width: auto;
        max-height: 40px;
        height: 40px
    }
    .model-detail-specification-table-print__image {
        grid-column: 1 / -1;
    }
    .model-detail-specification-table__fixed-col-heading {
        display: none;
    }
    .model-detail-specification-table-print__col-heading {
        color: #e58e1a;
        font-weight: 700;
        position: relative;
        font-size: 12px;
        line-height: 20px;
        background-color: #ffffff;
        -webkit-print-color-adjust: exact;
        padding: 8px 0 4px 16px;
    }
    .model-detail-specification-table-print__spec {
        color: #1e1e1d;
        font-size: 12px;
        line-height: 20px;
        border-bottom: 1px solid #d1d2d4;
        display: flex;
        height: 100%;
        align-items: center;
        padding: 16px;
    }
    .model-detail-specification-table-print__spec--even {
        background-color: #ffffff;
        -webkit-print-color-adjust: exact;
    }
    .model-detail-specification-table-print__spec--odd {
        background-color: #fbfbfb;
        -webkit-print-color-adjust: exact;
    }
    .model-detail-specification-table-print__spec--last-row {
        border: 0;
    }
    .model-detail-specification-table-print__spec-category-row {
        color: #1e1e1d;
        font-weight: 700;
        background-color: #f4f4f4;
        -webkit-print-color-adjust: exact;
        display: flex;
        grid-column: 1/-1;
        cursor: pointer;
    }
    .model-detail-specification-table-print__spec-category-row__empty-row {
        flex-grow: 1;
    }
    .model-detail-specification-table-print__spec-category-row__inner-box-wrapper {
        z-index: 2;
        background-color: #f4f4f4;
        -webkit-print-color-adjust: exact;
    }
    .model-detail-specification-table-print__spec-category-row__border-collapsed {
        border-bottom: 1px solid #d1d2d4;
    }
    .model-detail-specification-table-print__spec-category-row__inner-box {
        margin-left: 32px;
        padding: 16px 0;
    }
    .model-detail-specification-table-print__left-side-accordion-spec-title {
        font-size: 12px;
        line-height: 20px;
        background-color: #fbfbfb;
        -webkit-print-color-adjust: exact;
        font-weight: 600;
        display: flex;
        height: 100%;
        z-index: 2;
    }
    .model-detail-specification-table-print__left-side-accordion-spec-title__inner-box {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #d1d2d4;
        margin-left: 32px;
        padding: 16px 16px 16px 0;
    }
    .model-detail-specification-table-print__left-side-accordion-spec-title__inner-box--last-row {
        border: 0;
    }
    .model-detail-specification-table-print__spec-row-child {
      height: 100%;
      display: flex;
      align-items: center;
      opacity: 1;
    }
    .model-detail-specification-table__notes{
        background-color:#ffffff;
    }
    .model-detail-specification-table__notes--wrapper{
        width: 50%;
        padding: 24px 32px 38px;
    }
    .model-detail-specification-table__notes--wrapper__title{
        font-size:12px;
        line-height:20px;
        letter-spacing:0;
        color:#000000;
        font-weight:700;
        padding-bottom:8px;
    }
    .model-detail-specification-table__notes--wrapper__description{
        font-size:12px;
        line-height:20px;
        letter-spacing:0;
        color:#000000;
        font-weight:400;
    }
    `;
}
